/* Curl ID result copy, from Curl ID Email Flows v4.1 (Email 1 and Email 3) and Kit Routines V3 (Final), Oct 13 2026. Edit copy here; kit contents must match the V3 grid. */
window.CURL_ID_COPY = {
"protective-goddess-2": {
"id": "protective-goddess",
"type": 2,
"name": "Protective Goddess",
"curlTypeLabel": "Type 2, wavy",
"strands": "fine",
"porosity": "low",
"tagline": "Your hair is a beautiful part of your divine goddess, and it deserves to be protected.",
"explained": [
"Your strands are fine. Each one is delicate and can only hold a little product at a time. Too much, and it sits on top, weighs your waves down and leaves residue.",
"Your porosity is low. Your cuticles, the outer layer of each strand, lie tightly closed. Water and products find it hard to get in, so they tend to stay on the outside instead of being absorbed.",
"Together, that means: your hair can feel dry even right after conditioning, products seem to sit on top of it, and your waves don’t form evenly. And the rich products that promised moisture only added buildup.",
"That’s not your hair being difficult. It’s your hair asking for a different approach: small amounts, warmth to open your cuticles, and patient hands that massage every layer in."
],
"superpower": "once moisture is in, your hair holds on to it. The right technique unlocks definition that lasts.",
"challenge": "getting water and product into your strands without building up on fine hair.",
"whyLetDown": "most products are made to be used generously. On fine, low-porosity hair, generous means buildup: the product never gets in, it just sits on top.",
"symptoms": [
"It feels dry, even right after conditioning",
"Products sit on top of your hair or leave a residue",
"Your waves don’t form evenly"
],
"routine": {
"definition": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Define",
"product": "gelly",
"text": "for definition and volume, without weight."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, so your hair absorbs everything and your definition sets."
}
],
"volume": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Volume",
"product": "mousse",
"text": "for big, weightless volume."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, with your head tilted, for lift at the roots."
}
],
"both": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Define",
"product": "gelly",
"text": "for definition and volume, without weight."
},
{
"verb": "Volume",
"product": "mousse",
"text": "over your gel, for volume."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, then scrunch out the cast for volume."
}
]
},
"kit": {
"definition": {
"price": 74,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture, light enough for fine strands"
},
{
"product": "gelly",
"line": "ultra-light gel that hydrates: definition without weight"
}
]
},
"volume": {
"price": 74,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture, light enough for fine strands"
},
{
"product": "mousse",
"line": "big, weightless volume, even on fine hair"
}
]
},
"both": {
"price": 100,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture, light enough for fine strands"
},
{
"product": "gelly",
"line": "ultra-light gel that hydrates: definition without weight"
},
{
"product": "mousse",
"line": "layered over your gel: softens the cast and lifts your roots for volume"
}
]
}
},
"extraStylers": [],
"addons": {
"refresh": [
"daily_curl_booster",
"mistify"
],
"treatments": [
{
"product": "renaissance",
"cadence": "monthly reset"
},
{
"product": "unconditional_love",
"cadence": "every 2nd wash day, as a deep treatment"
}
]
},
"applying": null
},
"protective-goddess-3": {
"id": "protective-goddess",
"type": 3,
"name": "Protective Goddess",
"curlTypeLabel": "Type 3, curly",
"strands": "fine",
"porosity": "low",
"tagline": "Your hair is a beautiful part of your divine goddess, and it deserves to be protected.",
"explained": [
"Your strands are fine. Each one is delicate and can only hold a little product at a time. Too much, and it sits on top, weighs your curls down and leaves residue.",
"Your porosity is low. Your cuticles, the outer layer of each strand, lie tightly closed. Water and products find it hard to get in, so they tend to stay on the outside instead of being absorbed.",
"Together, that means: your hair can feel dry even right after conditioning, products seem to sit on top of it, and your curls don’t form evenly. And the rich products that promised moisture only added buildup.",
"That’s not your hair being difficult. It’s your hair asking for a different approach: small amounts, warmth to open your cuticles, and patient hands that massage every layer in."
],
"superpower": "once moisture is in, your hair holds on to it. The right technique unlocks definition that lasts.",
"challenge": "getting water and product into your strands without building up on fine hair.",
"whyLetDown": "most products are made to be used generously. On fine, low-porosity hair, generous means buildup: the product never gets in, it just sits on top.",
"symptoms": [
"It feels dry, even right after conditioning",
"Products sit on top of your hair or leave a residue",
"Your curls don’t form evenly"
],
"routine": {
"definition": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "a very small amount, completely melted, so the hydration stays in."
},
{
"verb": "Define",
"product": "gelly",
"text": "for definition and volume, without weight."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, so your hair absorbs everything and your definition sets."
}
],
"volume": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "a very small amount, completely melted, so the hydration stays in."
},
{
"verb": "Style",
"product": "holy_cream",
"text": "for soft, touchable curls and volume."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, with your head tilted, for lift at the roots."
}
],
"both": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Define",
"product": "gelly",
"text": "for definition and volume, without weight."
},
{
"verb": "Volume",
"product": "mousse",
"text": "over your gel, for volume."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, then scrunch out the cast for volume."
}
]
},
"kit": {
"definition": {
"price": 101,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture, light enough for fine strands"
},
{
"product": "moisture_lock",
"line": "seals the hydration in and gives your definition more hold (a very small amount, fully melted)"
},
{
"product": "gelly",
"line": "ultra-light gel that hydrates: definition without weight"
}
]
},
"volume": {
"price": 99,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture, light enough for fine strands"
},
{
"product": "moisture_lock",
"line": "seals the hydration in and gives your definition more hold (a very small amount, fully melted)"
},
{
"product": "holy_cream",
"line": "leave-in and styler in one: soft, touchable volume"
}
]
},
"both": {
"price": 100,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture, light enough for fine strands"
},
{
"product": "gelly",
"line": "ultra-light gel that hydrates: definition without weight"
},
{
"product": "mousse",
"line": "layered over your gel: softens the cast and lifts your roots for volume"
}
]
}
},
"extraStylers": [
"mousse"
],
"addons": {
"refresh": [
"daily_curl_booster",
"mistify"
],
"treatments": [
{
"product": "renaissance",
"cadence": "monthly reset"
},
{
"product": "unconditional_love",
"cadence": "every 2nd wash day, as a deep treatment"
}
]
},
"applying": {
"intro": "Your hair is fine, and it’s low porosity. That’s exactly why it’s so important to apply your products correctly, and to use the right amount. Fine strands can only hold a very small amount of product. And low-porosity hair can only absorb so much at a time, because the product can’t penetrate deeply enough into the strand. Whatever your hair can’t take in stays on the outside, weighs your curls down and shows up as residue. Teaching your hair to absorb better is a retraining, and it takes a little time.",
"steps": [
"Use small amounts, for every layer. Your conditioner, your seal, your styler: start with less than you think. You can always add a touch more next wash day.",
"Massage every layer in. Work each product in with your hands, section by section, until it’s absorbed into the hair shaft, before the next layer goes on. This manual massage is what moves the product into your strands, instead of leaving it on top."
],
"moistureLock": "Your Moisture Lock. Moisture Lock gives your curls more protection, more definition and more hold, and your definition lasts much longer. It just needs extra care:",
"mlSteps": [
"Use very little. Less than you think.",
"Melt it completely. Rub it between your palms until it’s fully melted and completely liquid, with no soft bits left.",
"Massage it in. Smooth it over each section, then massage it in thoroughly, so it’s absorbed instead of sitting on top."
],
"after": [
"The same rule for every product in your routine: a small amount, massaged in with care until it’s absorbed into your hair, before the next layer goes on. That extra attention is what turns product into moisture."
],
"residue": {
"intro": "If you see residue. White flakes, residue, a coated feel, or curls that look weighed down or flat: they all tell us the same thing. More product went on than your hair could take in. It’s not your hair failing, and it’s very fixable:",
"steps": [
"Use less of each product.",
"Massage every layer in longer, making sure each product is fully absorbed before the next one goes on.",
"Leave Moisture Lock out of your routine for now, and pay even more attention to massaging in all the other layers.",
"Dry fully with heat, with a diffuser or hooded dryer. This step is super important: it helps your curls absorb what you’ve applied."
],
"outro": [
"Once your hair absorbs better, bring Moisture Lock back in: a very small amount, completely melted, and massaged in.",
"If residue is your biggest frustration, keep it simple for a while: Moisture Rescue, then your gel, each massaged in well."
],
"volumeDefinitionOnly": "Your Volume & Definition kit leaves Moisture Lock out on purpose, to keep your strands light and free of residue. If you’d like more hold and longer-lasting definition later, you can add it, following the steps above."
}
}
},
"protective-goddess-4": {
"id": "protective-goddess",
"type": 4,
"name": "Protective Goddess",
"curlTypeLabel": "Type 4, coily",
"strands": "fine",
"porosity": "low",
"tagline": "Your hair is a beautiful part of your divine goddess, and it deserves to be protected.",
"explained": [
"Your strands are fine. Each one is delicate and can only hold a little product at a time. Too much, and it sits on top, weighs your coils down and leaves residue.",
"Your porosity is low. Your cuticles, the outer layer of each strand, lie tightly closed. Water and products find it hard to get in, so they tend to stay on the outside instead of being absorbed.",
"Together, that means: your hair can feel dry even right after conditioning, products seem to sit on top of it, and your coils don’t form evenly. And the rich products that promised moisture only added buildup.",
"That’s not your hair being difficult. It’s your hair asking for a different approach: small amounts, warmth to open your cuticles, and patient hands that massage every layer in."
],
"superpower": "once moisture is in, your hair holds on to it. The right technique unlocks definition that lasts.",
"challenge": "getting water and product into your strands without building up on fine hair.",
"whyLetDown": "most products are made to be used generously. On fine, low-porosity hair, generous means buildup: the product never gets in, it just sits on top.",
"symptoms": [
"It feels dry, even right after conditioning",
"Products sit on top of your hair or leave a residue",
"Your coils don’t form evenly"
],
"routine": {
"definition": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "a very small amount, completely melted, so the hydration stays in."
},
{
"verb": "Define",
"product": "hold_it",
"text": "for strong, long-lasting definition."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, so your hair absorbs everything and your definition sets."
}
],
"volume": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "a very small amount, completely melted, so the hydration stays in."
},
{
"verb": "Style",
"product": "curl_butter",
"text": "for medium hold, volume and definition."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, with your head tilted, for lift at the roots."
}
],
"both": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Define",
"product": "hold_it",
"text": "for strong, long-lasting definition."
},
{
"verb": "Volume",
"product": "mousse",
"text": "over your gel, for volume."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, then scrunch out the cast for volume."
}
]
},
"kit": {
"definition": {
"price": 101,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture, light enough for fine strands"
},
{
"product": "moisture_lock",
"line": "seals the hydration in and gives your definition more hold (a very small amount, fully melted)"
},
{
"product": "hold_it",
"line": "strong hold, flexible finish: definition that lasts and lasts"
}
]
},
"volume": {
"price": 101,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture, light enough for fine strands"
},
{
"product": "moisture_lock",
"line": "seals the hydration in and gives your definition more hold (a very small amount, fully melted)"
},
{
"product": "curl_butter",
"line": "medium hold, deep moisture, definition and volume"
}
]
},
"both": {
"price": 100,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture, light enough for fine strands"
},
{
"product": "hold_it",
"line": "strong hold, flexible finish: definition that lasts and lasts"
},
{
"product": "mousse",
"line": "layered over your gel: softens the cast and lifts your roots for volume"
}
]
}
},
"extraStylers": [
"gelly",
"mousse",
"holy_cream"
],
"addons": {
"refresh": [
"daily_curl_booster",
"mistify"
],
"treatments": [
{
"product": "renaissance",
"cadence": "monthly reset"
},
{
"product": "unconditional_love",
"cadence": "every 2nd wash day, as a deep treatment"
}
]
},
"applying": {
"intro": "Your hair is fine, and it’s low porosity. That’s exactly why it’s so important to apply your products correctly, and to use the right amount. Fine strands can only hold a very small amount of product. And low-porosity hair can only absorb so much at a time, because the product can’t penetrate deeply enough into the strand. Whatever your hair can’t take in stays on the outside, weighs your coils down and shows up as residue. Teaching your hair to absorb better is a retraining, and it takes a little time.",
"steps": [
"Use small amounts, for every layer. Your conditioner, your seal, your styler: start with less than you think. You can always add a touch more next wash day.",
"Massage every layer in. Work each product in with your hands, section by section, until it’s absorbed into the hair shaft, before the next layer goes on. This manual massage is what moves the product into your strands, instead of leaving it on top."
],
"moistureLock": "Your Moisture Lock. Moisture Lock gives your coils more protection, more definition and more hold, and your definition lasts much longer. It just needs extra care:",
"mlSteps": [
"Use very little. Less than you think.",
"Melt it completely. Rub it between your palms until it’s fully melted and completely liquid, with no soft bits left.",
"Massage it in. Smooth it over each section, then massage it in thoroughly, so it’s absorbed instead of sitting on top."
],
"after": [
"The same rule for every product in your routine: a small amount, massaged in with care until it’s absorbed into your hair, before the next layer goes on. That extra attention is what turns product into moisture."
],
"residue": {
"intro": "If you see residue. White flakes, residue, a coated feel, or coils that look weighed down or flat: they all tell us the same thing. More product went on than your hair could take in. It’s not your hair failing, and it’s very fixable:",
"steps": [
"Use less of each product.",
"Massage every layer in longer, making sure each product is fully absorbed before the next one goes on.",
"Leave Moisture Lock out of your routine for now, and pay even more attention to massaging in all the other layers.",
"Dry fully with heat, with a diffuser or hooded dryer. This step is super important: it helps your coils absorb what you’ve applied."
],
"outro": [
"Once your hair absorbs better, bring Moisture Lock back in: a very small amount, completely melted, and massaged in.",
"If residue is your biggest frustration, keep it simple for a while: Moisture Rescue, then your gel, each massaged in well."
],
"volumeDefinitionOnly": "Your Volume & Definition kit leaves Moisture Lock out on purpose, to keep your strands light and free of residue. If you’d like more hold and longer-lasting definition later, you can add it, following the steps above."
}
}
},
"tlc-queen-2": {
"id": "tlc-queen",
"type": 2,
"name": "TLC Queen",
"curlTypeLabel": "Type 2, wavy",
"strands": "fine",
"porosity": "medium to high",
"tagline": "TLC stands for tender, love and care. That’s exactly what your crown is craving.",
"explained": [
"Your strands are fine. Each one is delicate, so it needs strength and gentle hands. Rough detangling, heavy products and too much manipulation are what break fine hair.",
"Your porosity is medium to high. Your cuticles, the outer layer of each strand, are more open. So your hair drinks in water easily, and lets it go just as easily unless it’s sealed in.",
"Together, that means: your hair can feel beautifully soft on wash day, and dry again a day or two later. It’s very delicate and can break easily, so it doesn’t like a lot of manipulation. And it gets weighed down by the rich products that promised to fix the dryness.",
"That’s not your hair being difficult. It’s your hair being honest. It’s been telling you exactly what it needs: strength to protect your fine strands, and light layers that hold hydration in without flattening your waves."
],
"superpower": "your hair absorbs moisture easily and responds beautifully to hydration and protein. Cared for the right way, TLC Queen waves are vibrant, defined and full of life.",
"challenge": "keeping that moisture in while protecting your fine strands from breakage.",
"whyLetDown": "the heavy ones weighed your fine waves down, and the light ones couldn’t hold the moisture in. Your hair needed strength and light hydration, in the right order.",
"symptoms": [
"It feels dry again a day or two after wash day",
"It breaks easily, even when you’re gentle",
"Heavy products weigh it down and flatten your waves"
],
"routine": {
"definition": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Define",
"product": "gelly",
"text": "for definition and volume, without weight."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, so your hair absorbs everything and your definition sets."
}
],
"volume": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Volume",
"product": "mousse",
"text": "for big, weightless volume."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, with your head tilted, for lift at the roots."
}
],
"both": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Define",
"product": "gelly",
"text": "for definition and volume, without weight."
},
{
"verb": "Volume",
"product": "mousse",
"text": "over your gel, for volume."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, then scrunch out the cast for volume."
}
]
},
"kit": {
"definition": {
"price": 76,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein to strengthen fine strands"
},
{
"product": "gelly",
"line": "ultra-light gel that hydrates: definition without weight"
}
]
},
"volume": {
"price": 76,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein to strengthen fine strands"
},
{
"product": "mousse",
"line": "big, weightless volume, even on fine hair"
}
]
},
"both": {
"price": 102,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein to strengthen fine strands"
},
{
"product": "gelly",
"line": "ultra-light gel that hydrates: definition without weight"
},
{
"product": "mousse",
"line": "layered over your gel: softens the cast and lifts your roots for volume"
}
]
}
},
"extraStylers": [
"holy_cream"
],
"addons": {
"refresh": [
"daily_curl_booster",
"mistify"
],
"treatments": [
{
"product": "curl_repair",
"cadence": "every 3 to 4 weeks"
},
{
"product": "renaissance",
"cadence": "monthly reset"
}
]
},
"applying": null
},
"tlc-queen-3": {
"id": "tlc-queen",
"type": 3,
"name": "TLC Queen",
"curlTypeLabel": "Type 3, curly",
"strands": "fine",
"porosity": "medium to high",
"tagline": "TLC stands for tender, love and care. That’s exactly what your crown is craving.",
"explained": [
"Your strands are fine. Each one is delicate, so it needs strength and gentle hands. Rough detangling, heavy products and too much manipulation are what break fine hair.",
"Your porosity is medium to high. Your cuticles, the outer layer of each strand, are more open. So your hair drinks in water easily, and lets it go just as easily unless it’s sealed in.",
"Together, that means: your hair can feel beautifully soft on wash day, and dry again a day or two later. It’s very delicate and can break easily, so it doesn’t like a lot of manipulation. And it gets weighed down by the rich products that promised to fix the dryness.",
"That’s not your hair being difficult. It’s your hair being honest. It’s been telling you exactly what it needs: strength to protect your fine strands, and a seal to hold every drop of hydration in."
],
"superpower": "your hair absorbs moisture easily and responds beautifully to hydration and protein. Cared for the right way, TLC Queen curls are vibrant, defined and full of life.",
"challenge": "keeping that moisture in while protecting your fine strands from breakage.",
"whyLetDown": "the heavy ones weighed your fine strands down, and the light ones couldn’t hold the moisture in. Your hair needed both strength and a seal, in the right order.",
"symptoms": [
"It feels dry again a day or two after wash day",
"It breaks easily, even when you’re gentle",
"Heavy products weigh it down and flatten your curls"
],
"routine": {
"definition": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "a very small amount, completely melted, so the hydration stays in."
},
{
"verb": "Define",
"product": "gelly",
"text": "for definition and volume, without weight."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, so your hair absorbs everything and your definition sets."
}
],
"volume": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "a very small amount, completely melted, so the hydration stays in."
},
{
"verb": "Style",
"product": "holy_cream",
"text": "for soft, touchable curls and volume."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, with your head tilted, for lift at the roots."
}
],
"both": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Cream first",
"product": "holy_cream",
"text": "your leave-in and soft styler, under your gel."
},
{
"verb": "Define",
"product": "gelly",
"text": "for definition and volume, without weight."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, then scrunch out the cast for volume."
}
]
},
"kit": {
"definition": {
"price": 103,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein to strengthen fine strands"
},
{
"product": "moisture_lock",
"line": "seals the hydration in and gives your definition more hold (a very small amount, fully melted)"
},
{
"product": "gelly",
"line": "ultra-light gel that hydrates: definition without weight"
}
]
},
"volume": {
"price": 101,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein to strengthen fine strands"
},
{
"product": "moisture_lock",
"line": "seals the hydration in and gives your definition more hold (a very small amount, fully melted)"
},
{
"product": "holy_cream",
"line": "leave-in and styler in one: soft, touchable volume"
}
]
},
"both": {
"price": 100,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein to strengthen fine strands"
},
{
"product": "holy_cream",
"line": "leave-in and soft styler in one, under your gel"
},
{
"product": "gelly",
"line": "ultra-light gel that hydrates: definition without weight"
}
]
}
},
"extraStylers": [
"curl_butter"
],
"addons": {
"refresh": [
"daily_curl_booster",
"mistify"
],
"treatments": [
{
"product": "curl_repair",
"cadence": "every 3 to 4 weeks"
},
{
"product": "renaissance",
"cadence": "monthly reset"
}
]
},
"applying": {
"intro": "Your hair is fine. That’s exactly why it’s so important to apply your products correctly, and to use the right amount. Fine strands can only hold a very small amount of product. Anything extra has nowhere to go: it sits on the surface, weighs your curls down and can show up as residue.",
"steps": [
"Use small amounts, for every layer. Your conditioner, your seal, your styler: start with less than you think. You can always add a touch more next wash day.",
"Massage every layer in. Work each product in with your hands, section by section, until it’s absorbed into the hair shaft, before the next layer goes on. This manual massage is what moves the product into your strands, instead of leaving it on top."
],
"moistureLock": "Your Moisture Lock. Moisture Lock gives your curls more protection, more definition and more hold, and your definition lasts much longer. It just needs extra care:",
"mlSteps": [
"Use very little. Less than you think.",
"Melt it completely. Rub it between your palms until it’s fully melted and completely liquid, with no soft bits left.",
"Massage it in. Smooth it over each section, then massage it in thoroughly, so it’s absorbed instead of sitting on top."
],
"after": [
"The same rule for every product in your routine: a small amount, massaged in with care until it’s absorbed into your hair, before the next layer goes on. That extra attention is what turns product into moisture."
],
"residue": {
"intro": "If you see residue. White flakes, residue, a coated feel, or curls that look weighed down or flat: they all tell us the same thing. More product went on than your hair could take in. It’s not your hair failing, and it’s very fixable:",
"steps": [
"Use less of each product.",
"Massage every layer in longer, making sure each product is fully absorbed before the next one goes on.",
"Leave Moisture Lock out of your routine for now, and pay even more attention to massaging in all the other layers.",
"Dry fully with heat, with a diffuser or hooded dryer. This step is super important: it helps your curls absorb what you’ve applied."
],
"outro": [
"Once your hair absorbs better, bring Moisture Lock back in: a very small amount, completely melted, and massaged in."
],
"volumeDefinitionOnly": "Your Volume & Definition kit leaves Moisture Lock out on purpose, to keep your strands light. If you’d like more hold and longer-lasting definition later, you can add it, following the steps above."
}
}
},
"tlc-queen-4": {
"id": "tlc-queen",
"type": 4,
"name": "TLC Queen",
"curlTypeLabel": "Type 4, coily",
"strands": "fine",
"porosity": "medium to high",
"tagline": "TLC stands for tender, love and care. That’s exactly what your crown is craving.",
"explained": [
"Your strands are fine. Each one is delicate, so it needs strength and gentle hands. Rough detangling, heavy products and too much manipulation are what break fine hair.",
"Your porosity is medium to high. Your cuticles, the outer layer of each strand, are more open. So your hair drinks in water easily, and lets it go just as easily unless it’s sealed in.",
"Together, that means: your hair can feel beautifully soft on wash day, and dry again a day or two later. It’s very delicate and can break easily, so it doesn’t like a lot of manipulation. And it gets weighed down by the rich products that promised to fix the dryness.",
"That’s not your hair being difficult. It’s your hair being honest. It’s been telling you exactly what it needs: strength to protect your fine strands, and a seal to hold every drop of hydration in."
],
"superpower": "your hair absorbs moisture easily and responds beautifully to hydration and protein. Cared for the right way, TLC Queen coils are vibrant, defined and full of life.",
"challenge": "keeping that moisture in while protecting your fine strands from breakage.",
"whyLetDown": "the heavy ones weighed your fine strands down, and the light ones couldn’t hold the moisture in. Your hair needed both strength and a seal, in the right order.",
"symptoms": [
"It feels dry again a day or two after wash day",
"It breaks easily, even when you’re gentle",
"Heavy products weigh it down and flatten your coils"
],
"routine": {
"definition": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "a very small amount, completely melted, so the hydration stays in."
},
{
"verb": "Define",
"product": "hold_it",
"text": "for strong, long-lasting definition."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, so your hair absorbs everything and your definition sets."
}
],
"volume": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "a very small amount, completely melted, so the hydration stays in."
},
{
"verb": "Style",
"product": "curl_butter",
"text": "for medium hold, volume and definition."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, with your head tilted, for lift at the roots."
}
],
"both": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Define",
"product": "hold_it",
"text": "for strong, long-lasting definition."
},
{
"verb": "Volume",
"product": "mousse",
"text": "over your gel, for volume."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, then scrunch out the cast for volume."
}
]
},
"kit": {
"definition": {
"price": 103,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein to strengthen fine strands"
},
{
"product": "moisture_lock",
"line": "seals the hydration in and gives your definition more hold (a very small amount, fully melted)"
},
{
"product": "hold_it",
"line": "strong hold, flexible finish: definition that lasts and lasts"
}
]
},
"volume": {
"price": 103,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein to strengthen fine strands"
},
{
"product": "moisture_lock",
"line": "seals the hydration in and gives your definition more hold (a very small amount, fully melted)"
},
{
"product": "curl_butter",
"line": "medium hold, deep moisture, definition and volume"
}
]
},
"both": {
"price": 102,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein to strengthen fine strands"
},
{
"product": "hold_it",
"line": "strong hold, flexible finish: definition that lasts and lasts"
},
{
"product": "mousse",
"line": "layered over your gel: softens the cast and lifts your roots for volume"
}
]
}
},
"extraStylers": [
"curl_butter"
],
"addons": {
"refresh": [
"daily_curl_booster",
"mistify"
],
"treatments": [
{
"product": "curl_repair",
"cadence": "every 3 to 4 weeks"
},
{
"product": "renaissance",
"cadence": "monthly reset"
}
]
},
"applying": {
"intro": "Your hair is fine. That’s exactly why it’s so important to apply your products correctly, and to use the right amount. Fine strands can only hold a very small amount of product. Anything extra has nowhere to go: it sits on the surface, weighs your coils down and can show up as residue.",
"steps": [
"Use small amounts, for every layer. Your conditioner, your seal, your styler: start with less than you think. You can always add a touch more next wash day.",
"Massage every layer in. Work each product in with your hands, section by section, until it’s absorbed into the hair shaft, before the next layer goes on. This manual massage is what moves the product into your strands, instead of leaving it on top."
],
"moistureLock": "Your Moisture Lock. Moisture Lock gives your coils more protection, more definition and more hold, and your definition lasts much longer. It just needs extra care:",
"mlSteps": [
"Use very little. Less than you think.",
"Melt it completely. Rub it between your palms until it’s fully melted and completely liquid, with no soft bits left.",
"Massage it in. Smooth it over each section, then massage it in thoroughly, so it’s absorbed instead of sitting on top."
],
"after": [
"The same rule for every product in your routine: a small amount, massaged in with care until it’s absorbed into your hair, before the next layer goes on. That extra attention is what turns product into moisture."
],
"residue": {
"intro": "If you see residue. White flakes, residue, a coated feel, or coils that look weighed down or flat: they all tell us the same thing. More product went on than your hair could take in. It’s not your hair failing, and it’s very fixable:",
"steps": [
"Use less of each product.",
"Massage every layer in longer, making sure each product is fully absorbed before the next one goes on.",
"Leave Moisture Lock out of your routine for now, and pay even more attention to massaging in all the other layers.",
"Dry fully with heat, with a diffuser or hooded dryer. This step is super important: it helps your coils absorb what you’ve applied."
],
"outro": [
"Once your hair absorbs better, bring Moisture Lock back in: a very small amount, completely melted, and massaged in."
],
"volumeDefinitionOnly": "Your Volume & Definition kit leaves Moisture Lock out on purpose, to keep your strands light. If you’d like more hold and longer-lasting definition later, you can add it, following the steps above."
}
}
},
"deluxe-princess-2": {
"id": "deluxe-princess",
"type": 2,
"name": "Deluxe Princess",
"curlTypeLabel": "Type 2, wavy",
"strands": "thick",
"porosity": "medium to high",
"tagline": "Your crown is rich and generous, and it deserves care that keeps up with it.",
"explained": [
"Your strands are medium to thick. They’re strong, they can handle rich products, and they love being fed.",
"Your porosity is medium to high. Your cuticles, the outer layer of each strand, are more open. So your hair drinks in water easily, and lets it go just as easily unless it’s held in.",
"Together, that means: your hair soaks up moisture beautifully on wash day, then lets it go just as fast. That’s when the dryness and the frizz come back, often by day two, and your waves lose their shape.",
"That’s not your hair being difficult. It’s your hair being honest. It’s been asking for two things: protein to keep your strands strong and smooth, and enough conditioner left in to hold the moisture."
],
"superpower": "your strands soak up rich products and thrive with protein, becoming stronger, smoother and healthier.",
"challenge": "holding on to hydration, so dryness and frizz don’t come back by day two.",
"whyLetDown": "light products couldn’t keep up with how much moisture your hair needs, and the moisture you did give it escaped by day two.",
"symptoms": [
"Frizz, especially in humidity",
"Dryness that comes back fast",
"Waves that lose their shape after a day or two"
],
"routine": {
"definition": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Define",
"product": "gelly",
"text": "for definition and volume, without weight."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, so your hair absorbs everything and your definition sets."
}
],
"volume": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Volume",
"product": "mousse",
"text": "for big, weightless volume."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, with your head tilted, for lift at the roots."
}
],
"both": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Define",
"product": "gelly",
"text": "for definition and volume, without weight."
},
{
"verb": "Volume",
"product": "mousse",
"text": "over your gel, for volume."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, then scrunch out the cast for volume."
}
]
},
"kit": {
"definition": {
"price": 76,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein; leave it in and style right away"
},
{
"product": "gelly",
"line": "ultra-light gel that hydrates: volume and definition"
}
]
},
"volume": {
"price": 76,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein; leave it in and style right away"
},
{
"product": "mousse",
"line": "big, weightless volume, even on fine hair"
}
]
},
"both": {
"price": 102,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein; leave it in and style right away"
},
{
"product": "gelly",
"line": "ultra-light gel that hydrates: volume and definition"
},
{
"product": "mousse",
"line": "layered over your gel: softens the cast and lifts your roots for volume"
}
]
}
},
"extraStylers": [
"holy_cream"
],
"addons": {
"refresh": [
"daily_curl_booster",
"mistify"
],
"treatments": [
{
"product": "curl_repair",
"cadence": "every 3 to 4 weeks"
},
{
"product": "renaissance",
"cadence": "monthly reset"
}
]
},
"applying": null
},
"deluxe-princess-3": {
"id": "deluxe-princess",
"type": 3,
"name": "Deluxe Princess",
"curlTypeLabel": "Type 3, curly",
"strands": "thick",
"porosity": "medium to high",
"tagline": "Your crown is rich and generous, and it deserves care that keeps up with it.",
"explained": [
"Your strands are medium to thick. They’re strong, they can handle rich products, and they love being fed.",
"Your porosity is medium to high. Your cuticles, the outer layer of each strand, are more open. So your hair drinks in water easily, and lets it go just as easily unless it’s held in.",
"Together, that means: your hair soaks up moisture beautifully on wash day, then lets it go just as fast. That’s when the dryness and the frizz come back, often by day two, and your curls lose their shape.",
"That’s not your hair being difficult. It’s your hair being honest. It’s been asking for two things: protein to keep your strands strong and smooth, and a seal to hold all that moisture in."
],
"superpower": "your strands soak up rich products and thrive with protein, becoming stronger, smoother and healthier.",
"challenge": "holding on to hydration, so dryness and frizz don’t come back by day two.",
"whyLetDown": "light products couldn’t keep up with how much moisture your hair needs, and rich products without a seal let it all escape by day two.",
"symptoms": [
"Frizz, especially in humidity",
"Dryness that comes back fast",
"Curls that lose their shape after a day or two"
],
"routine": {
"definition": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "completely melted, so the moisture stays in for days."
},
{
"verb": "Define",
"product": "hold_it",
"text": "for strong, long-lasting definition."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, so your hair absorbs everything and your definition sets."
}
],
"volume": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "completely melted, so the moisture stays in for days."
},
{
"verb": "Style",
"product": "curl_butter",
"text": "for medium hold, volume and definition."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, with your head tilted, for lift at the roots."
}
],
"both": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Moisture and volume",
"product": "curl_butter",
"text": "deep moisture and soft volume first."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "completely melted, so the moisture stays in for days."
},
{
"verb": "Define",
"product": "hold_it",
"text": "for strong, long-lasting definition."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, then scrunch out the cast for volume."
}
]
},
"kit": {
"definition": {
"price": 103,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein; leave it in and style right away"
},
{
"product": "moisture_lock",
"line": "seals the moisture in and keeps it there, for definition that lasts"
},
{
"product": "hold_it",
"line": "strong hold, flexible finish: definition that lasts and lasts"
}
]
},
"volume": {
"price": 103,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein; leave it in and style right away"
},
{
"product": "moisture_lock",
"line": "seals the moisture in and keeps it there, for definition that lasts"
},
{
"product": "curl_butter",
"line": "medium hold, deep moisture, definition and volume"
}
]
},
"both": {
"price": 129,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein; leave it in and style right away"
},
{
"product": "curl_butter",
"line": "deep moisture and soft volume, under your seal and gel"
},
{
"product": "moisture_lock",
"line": "seals the moisture in and keeps it there, for definition that lasts"
},
{
"product": "hold_it",
"line": "strong hold, flexible finish: definition that lasts and lasts"
}
]
}
},
"extraStylers": [
"holy_cream"
],
"addons": {
"refresh": [
"daily_curl_booster",
"mistify"
],
"treatments": [
{
"product": "curl_repair",
"cadence": "every 3 to 4 weeks"
},
{
"product": "renaissance",
"cadence": "monthly reset"
}
]
},
"applying": null
},
"deluxe-princess-4": {
"id": "deluxe-princess",
"type": 4,
"name": "Deluxe Princess",
"curlTypeLabel": "Type 4, coily",
"strands": "thick",
"porosity": "medium to high",
"tagline": "Your crown is rich and generous, and it deserves care that keeps up with it.",
"explained": [
"Your strands are medium to thick. They’re strong, they can handle rich products, and they love being fed.",
"Your porosity is medium to high. Your cuticles, the outer layer of each strand, are more open. So your hair drinks in water easily, and lets it go just as easily unless it’s held in.",
"Together, that means: your hair soaks up moisture beautifully on wash day, then lets it go just as fast. That’s when the dryness and the frizz come back, often by day two, and your coils lose their shape.",
"That’s not your hair being difficult. It’s your hair being honest. It’s been asking for two things: protein to keep your strands strong and smooth, and a seal to hold all that moisture in."
],
"superpower": "your strands soak up rich products and thrive with protein, becoming stronger, smoother and healthier.",
"challenge": "holding on to hydration, so dryness and frizz don’t come back by day two.",
"whyLetDown": "light products couldn’t keep up with how much moisture your hair needs, and rich products without a seal let it all escape by day two.",
"symptoms": [
"Frizz, especially in humidity",
"Dryness that comes back fast",
"Coils that lose their shape after a day or two"
],
"routine": {
"definition": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "completely melted, so the moisture stays in for days."
},
{
"verb": "Define",
"product": "hold_it",
"text": "for strong, long-lasting definition."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, so your hair absorbs everything and your definition sets."
}
],
"volume": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "completely melted, so the moisture stays in for days."
},
{
"verb": "Style",
"product": "curl_butter",
"text": "for medium hold, volume and definition."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, with your head tilted, for lift at the roots."
}
],
"both": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, so your hair keeps its moisture."
},
{
"verb": "Hydrate",
"product": "unconditional_love",
"text": "for deep hydration plus protein."
},
{
"verb": "Moisture and volume",
"product": "curl_butter",
"text": "deep moisture and soft volume first."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "completely melted, so the moisture stays in for days."
},
{
"verb": "Define",
"product": "hold_it",
"text": "for strong, long-lasting definition."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, then scrunch out the cast for volume."
}
]
},
"kit": {
"definition": {
"price": 103,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein; leave it in and style right away"
},
{
"product": "moisture_lock",
"line": "seals the moisture in and keeps it there, for definition that lasts"
},
{
"product": "hold_it",
"line": "strong hold, flexible finish: definition that lasts and lasts"
}
]
},
"volume": {
"price": 103,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein; leave it in and style right away"
},
{
"product": "moisture_lock",
"line": "seals the moisture in and keeps it there, for definition that lasts"
},
{
"product": "curl_butter",
"line": "medium hold, deep moisture, definition and volume"
}
]
},
"both": {
"price": 129,
"items": [
{
"product": "renew",
"line": "cleanses gently, without stripping your thirsty strands"
},
{
"product": "unconditional_love",
"line": "deep hydration plus protein; leave it in and style right away"
},
{
"product": "curl_butter",
"line": "deep moisture and soft volume, under your seal and gel"
},
{
"product": "moisture_lock",
"line": "seals the moisture in and keeps it there, for definition that lasts"
},
{
"product": "hold_it",
"line": "strong hold, flexible finish: definition that lasts and lasts"
}
]
}
},
"extraStylers": [
"holy_cream"
],
"addons": {
"refresh": [
"daily_curl_booster",
"mistify"
],
"treatments": [
{
"product": "curl_repair",
"cadence": "every 3 to 4 weeks"
},
{
"product": "renaissance",
"cadence": "monthly reset"
}
]
},
"applying": null
},
"velvet-babe-2": {
"id": "velvet-babe",
"type": 2,
"name": "Velvet Babe",
"curlTypeLabel": "Type 2, wavy",
"strands": "thick",
"porosity": "low",
"tagline": "Soft as velvet, strong at heart. Your hair holds on to everything you give it, once it gets in.",
"explained": [
"Your strands are medium to thick. They’re strong and can handle richer products, but they’re not invincible: too much manipulation still breaks them.",
"Your porosity is low. Your cuticles, the outer layer of each strand, lie tightly closed. Water and products find it hard to get in, so they tend to stay on the outside instead of being absorbed.",
"Together, that means: wash day can feel like a battle. Water beads on your hair, products sit on top, and it takes a long time to feel truly hydrated. But once moisture is in, it stays for days.",
"That’s not your hair being difficult. It’s your hair asking for a different approach: warmth, patience, and hands that massage every layer in."
],
"superpower": "once your hair is hydrated, it stays hydrated longer than almost any other Curl ID.",
"challenge": "getting moisture in, and handling strong hair gently so it doesn’t break.",
"whyLetDown": "rich products promised moisture, but on low-porosity hair they couldn’t get in. They sat on top, and your hair stayed thirsty underneath.",
"symptoms": [
"Hair that resists water on wash day",
"Products that sit on top of your hair",
"Breakage from too much manipulation"
],
"routine": {
"definition": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Define",
"product": "gelly",
"text": "for definition and volume, without weight."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, so your hair absorbs everything and your definition sets."
}
],
"volume": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Volume",
"product": "mousse",
"text": "for big, weightless volume."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, with your head tilted, for lift at the roots."
}
],
"both": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Define",
"product": "gelly",
"text": "for definition and volume, without weight."
},
{
"verb": "Volume",
"product": "mousse",
"text": "over your gel, for volume."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, then scrunch out the cast for volume."
}
]
},
"kit": {
"definition": {
"price": 74,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture; no rinse needed"
},
{
"product": "gelly",
"line": "ultra-light gel that hydrates: volume and definition"
}
]
},
"volume": {
"price": 74,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture; no rinse needed"
},
{
"product": "mousse",
"line": "big, weightless volume, even on fine hair"
}
]
},
"both": {
"price": 100,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture; no rinse needed"
},
{
"product": "gelly",
"line": "ultra-light gel that hydrates: volume and definition"
},
{
"product": "mousse",
"line": "layered over your gel: softens the cast and lifts your roots for volume"
}
]
}
},
"extraStylers": [
"holy_cream"
],
"addons": {
"refresh": [
"daily_curl_booster",
"mistify"
],
"treatments": [
{
"product": "renaissance",
"cadence": "monthly reset"
},
{
"product": "unconditional_love",
"cadence": "every 2nd wash day, as a deep treatment"
}
]
},
"applying": null
},
"velvet-babe-3": {
"id": "velvet-babe",
"type": 3,
"name": "Velvet Babe",
"curlTypeLabel": "Type 3, curly",
"strands": "thick",
"porosity": "low",
"tagline": "Soft as velvet, strong at heart. Your hair holds on to everything you give it, once it gets in.",
"explained": [
"Your strands are medium to thick. They’re strong and can handle richer products, but they’re not invincible: too much manipulation still breaks them.",
"Your porosity is low. Your cuticles, the outer layer of each strand, lie tightly closed. Water and products find it hard to get in, so they tend to stay on the outside instead of being absorbed.",
"Together, that means: wash day can feel like a battle. Water beads on your hair, products sit on top, and it takes a long time to feel truly hydrated. But once moisture is in, it stays for days.",
"That’s not your hair being difficult. It’s your hair asking for a different approach: warmth, patience, and hands that massage every layer in."
],
"superpower": "once your hair is hydrated, it stays hydrated longer than almost any other Curl ID.",
"challenge": "getting moisture in, and handling strong hair gently so it doesn’t break.",
"whyLetDown": "rich products promised moisture, but on low-porosity hair they couldn’t get in. They sat on top, and your hair stayed thirsty underneath.",
"symptoms": [
"Hair that resists water on wash day",
"Products that sit on top of your hair",
"Breakage from too much manipulation"
],
"routine": {
"definition": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "a very small amount, completely melted, so the hydration stays in."
},
{
"verb": "Define",
"product": "hold_it",
"text": "for strong, long-lasting definition."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, so your hair absorbs everything and your definition sets."
}
],
"volume": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "a very small amount, completely melted, so the hydration stays in."
},
{
"verb": "Define",
"product": "gelly",
"text": "for definition and volume, without weight."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, with your head tilted, for lift at the roots."
}
],
"both": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Define",
"product": "hold_it",
"text": "for strong, long-lasting definition."
},
{
"verb": "Volume",
"product": "mousse",
"text": "over your gel, for volume."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, then scrunch out the cast for volume."
}
]
},
"kit": {
"definition": {
"price": 101,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture; no rinse needed"
},
{
"product": "moisture_lock",
"line": "seals the hydration in and gives your definition more hold (a very small amount, fully melted)"
},
{
"product": "hold_it",
"line": "strong hold, flexible finish: definition that lasts and lasts"
}
]
},
"volume": {
"price": 101,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture; no rinse needed"
},
{
"product": "moisture_lock",
"line": "seals the hydration in and gives your definition more hold (a very small amount, fully melted)"
},
{
"product": "gelly",
"line": "ultra-light gel that hydrates: volume and definition"
}
]
},
"both": {
"price": 100,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture; no rinse needed"
},
{
"product": "hold_it",
"line": "strong hold, flexible finish: definition that lasts and lasts"
},
{
"product": "mousse",
"line": "layered over your gel: softens the cast and lifts your roots for volume"
}
]
}
},
"extraStylers": [
"curl_butter",
"holy_cream"
],
"addons": {
"refresh": [
"daily_curl_booster",
"mistify"
],
"treatments": [
{
"product": "renaissance",
"cadence": "monthly reset"
},
{
"product": "unconditional_love",
"cadence": "every 2nd wash day, as a deep treatment"
}
]
},
"applying": {
"intro": "Your hair is low porosity. That’s exactly why it’s so important to apply your products correctly, and to use the right amount. Low-porosity hair can only absorb so much at a time, because the product can’t penetrate deeply enough into the strand. Whatever isn’t absorbed stays on the outside, and that’s where residue comes from. Teaching your hair to absorb better is a retraining, and it takes a little time.",
"steps": [
"Use small amounts, for every layer. Your conditioner, your seal, your styler: start with less than you think. You can always add a touch more next wash day.",
"Massage every layer in. Work each product in with your hands, section by section, until it’s absorbed into the hair shaft, before the next layer goes on. This manual massage is what moves the product into your strands, instead of leaving it on top."
],
"moistureLock": "Your Moisture Lock. Moisture Lock gives your curls more protection, more definition and more hold, and your definition lasts much longer. It just needs extra care:",
"mlSteps": [
"Use very little. Less than you think.",
"Melt it completely. Rub it between your palms until it’s fully melted and completely liquid, with no soft bits left.",
"Massage it in. Smooth it over each section, then massage it in thoroughly, so it’s absorbed instead of sitting on top."
],
"after": [
"The same rule for every product in your routine: a small amount, massaged in with care until it’s absorbed into your hair, before the next layer goes on. That extra attention is what turns product into moisture."
],
"residue": {
"intro": "If you see residue. White flakes, residue, a coated feel, or curls that look weighed down or flat: they all tell us the same thing. More product went on than your hair could take in. It’s not your hair failing, and it’s very fixable:",
"steps": [
"Use less of each product.",
"Massage every layer in longer, making sure each product is fully absorbed before the next one goes on.",
"Leave Moisture Lock out of your routine for now, and pay even more attention to massaging in all the other layers.",
"Dry fully with heat, with a diffuser or hooded dryer. This step is super important: it helps your curls absorb what you’ve applied."
],
"outro": [
"Once your hair absorbs better, bring Moisture Lock back in: a very small amount, completely melted, and massaged in."
],
"volumeDefinitionOnly": "Your Volume & Definition kit leaves Moisture Lock out on purpose, to keep your strands light and free of residue. If you’d like more hold and longer-lasting definition later, you can add it, following the steps above."
}
}
},
"velvet-babe-4": {
"id": "velvet-babe",
"type": 4,
"name": "Velvet Babe",
"curlTypeLabel": "Type 4, coily",
"strands": "thick",
"porosity": "low",
"tagline": "Soft as velvet, strong at heart. Your hair holds on to everything you give it, once it gets in.",
"explained": [
"Your strands are medium to thick. They’re strong and can handle richer products, but they’re not invincible: too much manipulation still breaks them.",
"Your porosity is low. Your cuticles, the outer layer of each strand, lie tightly closed. Water and products find it hard to get in, so they tend to stay on the outside instead of being absorbed.",
"Together, that means: wash day can feel like a battle. Water beads on your hair, products sit on top, and it takes a long time to feel truly hydrated. But once moisture is in, it stays for days.",
"That’s not your hair being difficult. It’s your hair asking for a different approach: warmth, patience, and hands that massage every layer in."
],
"superpower": "once your hair is hydrated, it stays hydrated longer than almost any other Curl ID.",
"challenge": "getting moisture in, and handling strong hair gently so it doesn’t break.",
"whyLetDown": "rich products promised moisture, but on low-porosity hair they couldn’t get in. They sat on top, and your hair stayed thirsty underneath.",
"symptoms": [
"Hair that resists water on wash day",
"Products that sit on top of your hair",
"Breakage from too much manipulation"
],
"routine": {
"definition": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "a very small amount, completely melted, so the hydration stays in."
},
{
"verb": "Define",
"product": "hold_it",
"text": "for strong, long-lasting definition."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, so your hair absorbs everything and your definition sets."
}
],
"volume": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Seal",
"product": "moisture_lock",
"text": "a very small amount, completely melted, so the hydration stays in."
},
{
"verb": "Style",
"product": "curl_butter",
"text": "for medium hold, volume and definition."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, with your head tilted, for lift at the roots."
}
],
"both": [
{
"verb": "Cleanse",
"product": "renew",
"text": "gently, and keep your hair ready to absorb."
},
{
"verb": "Hydrate",
"product": "moisture_rescue",
"text": "made for hair that resists moisture."
},
{
"verb": "Moisture and volume",
"product": "curl_butter",
"text": "deep moisture and soft volume first."
},
{
"verb": "Define",
"product": "hold_it",
"text": "for strong, long-lasting definition."
},
{
"verb": "Dry",
"product": null,
"text": "with diffuse on medium heat, then scrunch out the cast for volume."
}
]
},
"kit": {
"definition": {
"price": 101,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture; no rinse needed"
},
{
"product": "moisture_lock",
"line": "seals the hydration in and gives your definition more hold (a very small amount, fully melted)"
},
{
"product": "hold_it",
"line": "strong hold, flexible finish: definition that lasts and lasts"
}
]
},
"volume": {
"price": 101,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture; no rinse needed"
},
{
"product": "moisture_lock",
"line": "seals the hydration in and gives your definition more hold (a very small amount, fully melted)"
},
{
"product": "curl_butter",
"line": "medium hold, deep moisture, definition and volume"
}
]
},
"both": {
"price": 100,
"items": [
{
"product": "renew",
"line": "cleanses gently and removes buildup, so moisture can get in"
},
{
"product": "moisture_rescue",
"line": "hydrates hair that resists moisture; no rinse needed"
},
{
"product": "curl_butter",
"line": "deep moisture and soft volume, under your seal and gel"
},
{
"product": "hold_it",
"line": "strong hold, flexible finish: definition that lasts and lasts"
}
]
}
},
"extraStylers": [
"holy_cream"
],
"addons": {
"refresh": [
"daily_curl_booster",
"mistify"
],
"treatments": [
{
"product": "renaissance",
"cadence": "monthly reset"
},
{
"product": "unconditional_love",
"cadence": "every 2nd wash day, as a deep treatment"
}
]
},
"applying": {
"intro": "Your hair is low porosity. That’s exactly why it’s so important to apply your products correctly, and to use the right amount. Low-porosity hair can only absorb so much at a time, because the product can’t penetrate deeply enough into the strand. Whatever isn’t absorbed stays on the outside, and that’s where residue comes from. Teaching your hair to absorb better is a retraining, and it takes a little time.",
"steps": [
"Use small amounts, for every layer. Your conditioner, your seal, your styler: start with less than you think. You can always add a touch more next wash day.",
"Massage every layer in. Work each product in with your hands, section by section, until it’s absorbed into the hair shaft, before the next layer goes on. This manual massage is what moves the product into your strands, instead of leaving it on top."
],
"moistureLock": "Your Moisture Lock. Moisture Lock gives your coils more protection, more definition and more hold, and your definition lasts much longer. It just needs extra care:",
"mlSteps": [
"Use very little. Less than you think.",
"Melt it completely. Rub it between your palms until it’s fully melted and completely liquid, with no soft bits left.",
"Massage it in. Smooth it over each section, then massage it in thoroughly, so it’s absorbed instead of sitting on top."
],
"after": [
"The same rule for every product in your routine: a small amount, massaged in with care until it’s absorbed into your hair, before the next layer goes on. That extra attention is what turns product into moisture."
],
"residue": {
"intro": "If you see residue. White flakes, residue, a coated feel, or coils that look weighed down or flat: they all tell us the same thing. More product went on than your hair could take in. It’s not your hair failing, and it’s very fixable:",
"steps": [
"Use less of each product.",
"Massage every layer in longer, making sure each product is fully absorbed before the next one goes on.",
"Leave Moisture Lock out of your routine for now, and pay even more attention to massaging in all the other layers.",
"Dry fully with heat, with a diffuser or hooded dryer. This step is super important: it helps your coils absorb what you’ve applied."
],
"outro": [
"Once your hair absorbs better, bring Moisture Lock back in: a very small amount, completely melted, and massaged in."
],
"volumeDefinitionOnly": "Your Volume & Definition kit leaves Moisture Lock out on purpose, to keep your strands light and free of residue. If you’d like more hold and longer-lasting definition later, you can add it, following the steps above."
}
}
}
};

/* Shared product map + Curl ID definitions, used by the quiz and Shop by Hair Type. Product IDs from the Curl ID org chart. */
window.CURL_ID_DATA = (function () {
  var PRODUCT_IDS = {
    renew: 3548574941284,
    moisture_rescue: 6763587600478,
    unconditional_love: 3548603580516,
    moisture_lock: 3548665577572,
    gelly: 7442976538718,
    mousse: 7442974343262,
    holy_cream: 6695243743326,
    hold_it: 3548669345892,
    curl_butter: 3548627402852,
    curl_repair: 6842321633374,
    renaissance: 6763588255838,
    refresh_kit: 7223642980446,
    wc_low: 7471680815198,
    wc_medhigh: 7471697887326,
    daily_curl_booster: null,
    mistify: null,
    cleansing_kit: null
  };
  var HANDLE_HINTS = {
    renew: /curl-renew/, moisture_rescue: /moisture-rescue|low-porosity-conditioner/, unconditional_love: /unconditional-love/,
    moisture_lock: /moisture-lock/, gelly: /gelly/, mousse: /mousse/, holy_cream: /holy-cream/, hold_it: /hold-it/,
    curl_butter: /curl-butter/, curl_repair: /curl-repair/, renaissance: /renaissance/, daily_curl_booster: /booster/,
    mistify: /mistify/, refresh_kit: /refresh-kit/, cleansing_kit: /^cleansing-ritual-kit$/,
    wc_low: /wash.*condition.*low|low-porosity.*kit/, wc_medhigh: /wash.*condition.*(medium|high)|(medium|high)-porosity.*kit/
  };
  /* Curl ID Kit variant IDs from the org chart (Definition, Volume). Volume & Definition is found
     as the sibling variant whose title contains both "volume" and "definition". */
  var KIT_VARIANTS = {
    'protective-goddess-2': [42091672043614, 42091672076382],
    'protective-goddess-3': [42091675975774, 42091675943006],
    'protective-goddess-4': [42091677646942, 42091677614174],
    'tlc-queen-2': [42091684855902, 42091684888670],
    'tlc-queen-3': [42091699470430, 42091699437662],
    'tlc-queen-4': [42091699929182, 42091699961950],
    'deluxe-princess-2': [42091707826270, 42091707793502],
    'deluxe-princess-3': [42091709857886, 42091709825118],
    'deluxe-princess-4': [42091712643166, 42091712610398],
    'velvet-babe-2': [42091701665886, 42091701698654],
    'velvet-babe-3': [42091703500894, 42091703468126],
    'velvet-babe-4': [42091703795806, 42091703828574]
  };
  var NAMES = {
    renew: 'Curl Renew Shampoo', moisture_rescue: 'Moisture Rescue Conditioner', unconditional_love: 'Unconditional Love Deep Conditioner',
    moisture_lock: 'Moisture Lock', gelly: 'Curl Devotion Gelly', mousse: 'Love is in the Hair Mousse', holy_cream: 'Holy Cream',
    hold_it: 'Hold It Right There! Gel', curl_butter: 'Curl Butter', curl_repair: 'Curl Repair', renaissance: 'Curl Renaissance',
    daily_curl_booster: 'Daily Curl Booster', mistify: 'Mistify', refresh_kit: 'Curl Refresh Kit', cleansing_kit: 'Cleansing Ritual Kit',
    wc_low: 'Wash & Condition Kit, Low Porosity', wc_medhigh: 'Wash & Condition Kit, Medium to High Porosity'
  };
  var CURL_IDS = {
    'protective-goddess': { name: 'Protective Goddess', strands: 'fine', por: 'low' },
    'tlc-queen': { name: 'TLC Queen', strands: 'fine', por: 'medhigh' },
    'deluxe-princess': { name: 'Deluxe Princess', strands: 'thick', por: 'medhigh' },
    'velvet-babe': { name: 'Velvet Babe', strands: 'thick', por: 'low' }
  };
  return { PRODUCT_IDS: PRODUCT_IDS, HANDLE_HINTS: HANDLE_HINTS, KIT_VARIANTS: KIT_VARIANTS, NAMES: NAMES, CURL_IDS: CURL_IDS };
})();
